import { useTranslation as useReactI18nTranslation } from 'react-i18next';

/**
 * A custom hook that provides translation functionality.
 * Wraps the react-i18next useTranslation hook to provide additional features if needed.
 */
export const useTranslation = () => {
    // Get the original translation functions
    const { t, i18n } = useReactI18nTranslation();

    // Return the translation functions
    return {
        /**
         * Translate a key
         * @param key - The translation key
         * @param options - Additional options for the translation
         * @returns The translated string
         */
        t,

        /**
         * The i18n instance
         */
        i18n,

        /**
         * Change the current language
         * @param lang - The language code to change to
         */
        changeLanguage: (lang: string) => i18n.changeLanguage(lang),

        /**
         * Get the current language
         * @returns The current language code
         */
        getCurrentLanguage: () => i18n.language,
    };
};
